import { render, staticRenderFns } from "./ProductFeaturesManager.vue?vue&type=template&id=fad1ff36"
import script from "./ProductFeaturesManager.vue?vue&type=script&lang=js"
export * from "./ProductFeaturesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports